namespace $.$$ {

	$mol_style_define( $shm_wordstat_task_list, {
		width: '16rem',

		Tasks: {
			flex: {
				direction: 'column',
				grow: 1,
			},
		},

		List_head: {
			flex: {
				grow: 1,
			},
		},

		Task_link: {
			justifyContent: 'flex-start',
		},

		Add_foot: {
			width: '100%',
			justifyContent: 'center',
			border: {
				radius: $mol_gap.round,
			},
			padding: $mol_gap.text,
		},
	} )

}
